module.exports = __webpack_public_path__ + "static/media/DooPeterElishHover.d436c5e1.svg";